export interface SubMenuItem {
  title: string;
  href: string;
  hasSubmenu?: boolean;
  subItems?: SubMenuItem[] | string[];
}

export interface NavLink {
  id: string;
  name: string;
  path: string;
  hasDropdown?: boolean;
  subItems?: SubMenuItem[];
}

const headerData: NavLink[] = [
  { id: "home", name: "Home", path: "/" },
  {
    id: "about",
    name: "About Us",
    path: "/about",
    hasDropdown: true,
    subItems: [
      {
        title: "Company Profile",
        href: "/about#company-profile",
        hasSubmenu: true,
        subItems: [
          {
            title: "Nippon Koei Bangladesh",
            href: "/about#nippon-koei-bangladesh",
            hasSubmenu: false,
          },
          {
            title: "Nippon Koei",
            href: "/about#nippon-koei",
            hasSubmenu: false,
          },
          {
            title: "ID&E",
            href: "/about#ide",
            hasSubmenu: false,
          },
        ],
      },
      {
        title: "Message from MD",
        href: "/about#message-from-md",
        hasSubmenu: false,
      },
      {
        title: "Philosophy",
        href: "/about#philosophy",
        hasSubmenu: false,
      },
      {
        title: "Mission & Vision",
        href: "/about#mission-vision",
        hasSubmenu: false,
      },
      {
        title: "Management",
        href: "/about#management",
        hasSubmenu: false,
      },
      {
        title: "Organization Chart",
        href: "/about#organization-chart",
        hasSubmenu: false,
      },
      {
        title: "Quality & Environment Policy",
        href: "/about#quality-environment-policy",
        hasSubmenu: false,
      },
      {
        title: "Certifications",
        href: "/about#certification",
        hasSubmenu: false,
      },
      {
        title: "Sustainability",
        href: "/sustainability",
        hasSubmenu: true,
        subItems: [
          {
            title: "Environment",
            href: "/sustainability/environment",
            hasSubmenu: false,
          },
          {
            title: "Social",
            href: "/sustainability/social",
            hasSubmenu: false,
          },
          {
            title: "Governance",
            href: "/sustainability/governance",
            hasSubmenu: false,
          },
        ],
      },
    ],
  },
  {
    id: "services",
    name: "Services",
    path: "/services",
    hasDropdown: true,
    subItems: [
      {
        title: "Spectrum of Services",
        href: "#spectrum",
        hasSubmenu: false,
      },
      {
        title: "Field of Services",
        href: "#field",
        hasSubmenu: true,
        subItems: [
          "Transportation",
          "Water Resources, Water Supply & Sewerage",
          "Urban, Regional & Industrial Development",
          "Environmental & Social Management",
          "Energy & Power",
          "Social & Economic Development",
        ],
      },
    ],
  },
  {
    id: "projects",
    name: "Projects",
    path: "/projects",
  },
  { id: "news", name: "News", path: "/news" },
  {
    id: "career",
    name: "Career",
    path: "/career",
    hasDropdown: true,
    subItems: [
      {
        title: "Current Openings",
        href: "#current-openings",
        hasSubmenu: false,
      },
      {
        title: "Life at Nippon Koei Bangladesh",
        href: "#life-at-nippon-koei",
        hasSubmenu: false,
      },
    ],
  },
  {
    id: "contact",
    name: "Contact",
    path: "/contact",
  },
];

export const getHeaderData = () => {
  return headerData;
};

export const getSubmenuData = (menuId: "about" | "services" | "career") => {
  const navLink = headerData.find((link) => link.id === menuId);
  return navLink?.subItems || [];
};
